<template>
  <div>
    <div>
      <div class="searchArea">
        <!-- <a-range-picker v-model:value="inputs.patroltime" :placeholder="['应巡开始时间','应巡结束时间']" :locale="locale" /> -->
        <a-select v-model:value="inputs.category" placeholder="类型">
          <!-- <a-select-option v-for="item in $store.state.areaNameType" :value="item.NAME">{{ item.NAME }}</a-select-option> -->
          <a-select-option value="Jingfang">经方</a-select-option>
          <a-select-option value="Mifang">秘方</a-select-option>
          <a-select-option value="药对">药对</a-select-option>
          <a-select-option value="穴位处方">穴位处方</a-select-option>
        </a-select>
        <a-input v-model:value="inputs.name" placeholder="名称" />
        <a-button type="primary" shape="circle" @click="search('')">
          <template #icon>
            <SearchOutlined />
          </template>
        </a-button>
        <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
        <a-button v-if="type == 'Jingfang'" style="margin-left: 10px" type="primary" @click="visible2 = true">
          <template #icon>
            <PlusOutlined />
          </template>
          新增处方
        </a-button>
        <a-button v-else-if="type == '穴位处方'" style="margin-left: 10px" type="primary" @click="visible4 = true">
          <template #icon>
            <PlusOutlined />
          </template>
          新增穴位处方
        </a-button>
      </div>

      <a-table class="ant-table-striped" :columns="columns" :data-source="data"
        :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id"
        :scroll="{ y: 550 }" :pagination="{ pageSize, total, current }" @change="search">

        <template #operation="{ record }">
          <div class="flex_sa">
            <div class="editable-row-operations">
              <span>
                <a @click="getPrescription(record)">详情</a>
              </span>
            </div>
            <div class="editable-row-operations">
              <span>
                <a v-if="type == '中药处方'" @click="editPrescription(record)">修改处方</a>
                <a v-else @click="editAcupoint(record)">修改处方</a>
              </span>
            </div>
            <div class="editable-row-operations flex_sa">
              <span v-if="editableData[record.id]">
                <a @click="save(record.id)">保存</a>
              </span>
              <span v-if="editableData[record.id]">
                <a @click="cancel(record.id)">取消</a>
              </span>
              <span v-else>
                <a @click="edit(record.id)">编辑</a>
              </span>
            </div>
            <div class="editable-row-operations">
              <span>
                <a-popconfirm title="是否确认删除" @confirm="onDelete(record.id)" okText="确认" cancelText="取消">
                  <a>删除</a>
                </a-popconfirm>
              </span>
            </div>

          </div>

        </template>
        <template #formula="{ record, text }">
          <div style="text-align: left;">{{ text }}</div>
        </template>
        <!-- 疾病 / 症候群：名称 + 紧跟其后的「关联」图标（整格可点，图标不会被挤出格子） -->
        <template #diseaseNames="{ text, record }">
          <div class="cell-link" :title="text" @click="openLink(record, 'disease')">
            <span class="cell-link-text">{{ text }}</span><form-outlined class="link-icon" />
          </div>
        </template>
        <template #syndromeNames="{ text, record }">
          <div class="cell-link" :title="text" @click="openLink(record, 'syndrome')">
            <span class="cell-link-text">{{ text }}</span><form-outlined class="link-icon" />
          </div>
        </template>
        <template v-for="col in ['name', 'description', 'source']" #[col]="{ text, record }" :key="col">
          <div class="cell-ellipsis" :title="editableData[record.id] ? '' : text">
            <!-- <div>{{record.id}}</div> -->
            <a-input v-if="editableData[record.id]" v-model:value="editableData[record.id][col]"
              @change="changeDataNameInitial(record)" style="margin: -5px 0" />
            <template v-else>{{ text }}</template>
          </div>
        </template>
      </a-table>

    </div>

    <!-- 查看 -->
    <getPrescription v-model="visible" :record="selectedRow" />
    <!-- 新增 -->
    <addPrescription v-model="visible2" />
    <!-- 编辑 -->
    <editPrescription v-model="visible3" :record="selectedRow" />

    <addAcupoint v-model="visible4" />
    <editAcupoint v-model="visible5" :record="selectedRow" />

    <!-- 关联疾病 / 症候群 -->
    <linkDiseaseSyndrome v-model="visibleLink" :record="selectedLinkRow" :kind="linkKind"
      @reload="search({ current })" />

  </div>
</template>


<style scoped>
.online {
  background: #40a9ff;
  border-color: #40a9ff;
}

.offline {
  background: #979596;
  border-color: #979596;
}

:deep(.ant-table-tbody > tr > td, .ant-table-thead > tr > th) {
  padding: 10px 8px;
}

/* 名称 / 描述列都走自定义 slot，antd 列上的 ellipsis 不生效，样式得自己写 */
/* 超长截断显示省略号，鼠标悬停（原生 title）看全文 */
.cell-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 备用：需要「超长自动换行、完整显示」时，把该列的 class 换成这个 */
.cell-wrap {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* 疾病 / 症候群列：名称 + 紧跟其后的「关联」图标 */
.cell-link {
  text-align: left;
  cursor: pointer;
  line-height: 1.6;
}

/* 名字可换行：超长（一个处方关联多个疾病）时图标仍紧跟在名字末尾，不会被挤出格子裁掉 */
.cell-link-text {
  white-space: normal;
  word-break: break-word;
}

.link-icon {
  color: #40a9ff;
  cursor: pointer;
  margin-left: 4px;
  vertical-align: -1px;
}
</style>


<script>
import {
  SearchOutlined,
  PlusOutlined,
  FormOutlined,
} from "@ant-design/icons-vue";
import { reactive } from "vue";
import { cloneDeep } from "lodash-es";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { Search, Update, Delete } from "/src/api/prescription.js";
import getPrescription from '/src/components/prescription/getPrescription.vue';
import addPrescription from '/src/components/prescription/addPrescription.vue';
import editPrescription from '/src/components/prescription/editPrescription.vue';
import addAcupoint from '/src/components/acupoint/addAcupoint.vue';
import editAcupoint from '/src/components/acupoint/editAcupoint.vue';
import linkDiseaseSyndrome from '/src/components/prescription/linkDiseaseSyndrome.vue';

// 穴位处方的 formula 是后端按「穴位名1,穴位名1」拼死的字符串（quantity 恒为 1），
// 展示时把每项末尾的 1 清掉；中药处方的用量（9、12 等）不受影响，只在穴位处方时调用
function cleanFormula(formula) {
  if (!formula) return formula;
  return String(formula)
    .split(/[,，、;；]/)
    .map((s) => s.replace(/1\s*$/, "").trim())
    .filter(Boolean)
    .join(",");
}

// 疾病/症候群列表 → 展示文本；兼容 [{id,name}] 与 ["名称"] 两种返回形态
function joinNames(list) {
  if (!Array.isArray(list) || !list.length) return "";
  return list
    .map((item) => (typeof item === "string" ? item : (item && item.name) || ""))
    .filter(Boolean)
    .join("、");
}

// 各类型处方在列表页显示哪些关联列
// 对应后端口径：经方/秘方只挂疾病列，药对只挂症候群列，穴位处方两列都显示
const LINK_COLUMN_CONFIG = {
  Jingfang: { disease: true, syndrome: false },
  Mifang: { disease: true, syndrome: false },
  药对: { disease: false, syndrome: true },
  穴位处方: { disease: true, syndrome: true },
};

export default {
  components: {
    SearchOutlined,
    PlusOutlined,
    FormOutlined,
    locale,
    editPrescription,
    addPrescription,
    getPrescription,
    addAcupoint,
    editAcupoint,
    linkDiseaseSyndrome
  },
  name: "处方管理",
  data() {
    return {
      modalBtn: "",
      modalIndex: "0",
      pageSize: 12,
      visible: false,
      visible2: false,
      category: "经方",
      visible3: false,
      visible4: false,
      visible5: false,
      // 关联疾病 / 症候群 弹窗
      visibleLink: false,
      linkKind: "disease",
      selectedLinkRow: {},
      active: undefined,
      id: undefined,
      total: 0,
      current: 1,
      inputs: {
        name: undefined,
        category: "Jingfang"
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      // 当前选中的处方类型（search 时同步，供 columns 计算属性判断关联列）
      type: "",
      data: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(
            `selectedRowKeys: ${selectedRowKeys}`,
            "selectedRows: ",
            selectedRows
          );
          this.selectedRows = selectedRows;
        },
        onSelect: (record, selected, selectedRows) => {
          console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          console.log(selected, selectedRows, changeRows);
        }
      },
      editableData: reactive({}),
      selectedRows: {}
      // doExcel: doExcel
    };
  },
  computed: {
    // 当前类型要显示哪些关联列（未知类型兜底两列都显示）
    linkCols() {
      return LINK_COLUMN_CONFIG[this.type] || { disease: true, syndrome: true };
    },
    // 列配置：疾病 / 症候群两列按类型动态增删，列宽同步补偿，合计始终 100%
    columns() {
      const cols = [
        { title: "名称", key: "name", dataIndex: "name", width: "22%", slots: { customRender: "name" } },
        { title: "描述", key: "description", dataIndex: "description", width: "18%", slots: { customRender: "description" } },
        { title: "处方", key: "formula", dataIndex: "formula", width: "25%", slots: { customRender: "formula" } },
      ];
      // 两列都在时各 10%，只显示一列时给 20%，保证 22+18+25+20+15 = 100%
      const both = this.linkCols.disease && this.linkCols.syndrome;
      if (this.linkCols.disease) {
        cols.push({
          title: "疾病",
          key: "diseaseNames",
          dataIndex: "diseaseNames",
          width: both ? "10%" : "20%",
          slots: { customRender: "diseaseNames" },
        });
      }
      if (this.linkCols.syndrome) {
        cols.push({
          title: "症候群",
          key: "syndromeNames",
          dataIndex: "syndromeNames",
          width: both ? "10%" : "20%",
          slots: { customRender: "syndromeNames" },
        });
      }
      cols.push({ title: "操作", dataIndex: "operation", width: "15%", slots: { customRender: "operation" } });
      return cols;
    },
  },
  created() { },
  mounted() {
    this.search("");
  },
  activated() {
    if (localStorage.getItem("refrashProject") == "true") {
      // this.search(1);
    }
    localStorage.setItem("refrashProject", false);
  },
  methods: {
    // 打开「关联疾病 / 症候群」弹窗
    openLink(record, kind) {
      this.linkKind = kind;
      this.selectedLinkRow = { ...record };
      this.visibleLink = true;
    },
    // 获取处方详情
    getPrescription(record) {
      this.visible = true
      this.selectedRow = { ...record }
      setTimeout(() => {
        console.log(this);
      }, 2000);
    },
    // 打开编辑处方
    editPrescription(record) {
      this.visible3 = true
      this.selectedRow = { ...record }
    },
    editAcupoint(record) {
      this.visible5 = true;
      console.log(record);

      this.selectedRow = { ...record }
    },
    resetForm() {
      this.inputs = {
        name: undefined,
      }
    },
    async onDelete(id) {
      this.editableData = {}
      let res = await Delete({ id })
      if (res.errCode == 0) {
        this.data = this.data.filter(function (item) {
          return item.id !== id;
        });
      } else {
        this.$message.error("删除失败", function () { });
      }

    },
    edit(id) {
      let _data = this.data;
      this.editableData[id] = cloneDeep(
        _data.filter(item => id === item.id)[0]
      );
    },
    async save(id) {
      let _data = this.data;

      //判断editableData和修改前是否一致，如果一致则不修改
      if (JSON.stringify(this.data.find((item) => item.id == id)) === JSON.stringify(this.editableData[id])) {
        // console.log("未修改")
        delete this.editableData[id];
        return;
      }
      let res = await Update(this.editableData[id])
      if (res.errCode == 0) {
        Object.assign(
          _data.filter(item => id === item.id)[0],
          this.editableData[id]
        );
        // console.log(JSON.stringify(this.editableData[id]))
        // console.log(this.editableData[id])
        delete this.editableData[id];
      }
    },
    cancel(id) {
      delete this.editableData[id];
    },
    tabsName(tabName) {
      this.$store.commit("changePage", { name: tabName.name, query: tabName.query });
    },
    async search(pagination) {
      let _this = this;
      this.editableData = {}
      let params = {
        name: this.inputs.name,
        nameInitial: this.inputs.nameInitial,
        gender: this.inputs.gender,
        isStandard: this.inputs.isStandard,
        category: this.inputs.category,
        type: this.inputs.category == '穴位处方' ? "穴位处方" : "中药处方",
        pageSize: this.pageSize,
      };
      this.type = this.inputs.category
      if (pagination == "") {
        params.current = 1
      } else {
        params.current = pagination.current;
        this.current = pagination.current;
      }
      let res = await Search(params)
      if (res.errCode == 0) {
        if (pagination == "") {
          // this.$message.success("查询成功", function () { });
          this.current = 1;
        }
        this.total = res.data.total;
        this.data = (res.data.records || []).map((item) => ({
          ...item,
          // 穴位处方：处方列去掉每项末尾拼进去的数字 1
          formula: item.type === "穴位处方" ? cleanFormula(item.formula) : item.formula,
          diseaseNames: joinNames(item.diseases),
          syndromeNames: joinNames(item.syndromes),
        }));
      } else {
        this.$message.error("查询失败", function () { });
      }
      // this.data = res
    },
  }
};
</script>